import { render, staticRenderFns } from "./HomeTitle.vue?vue&type=template&id=6fc72bb1&scoped=true&"
import script from "./HomeTitle.vue?vue&type=script&lang=js&"
export * from "./HomeTitle.vue?vue&type=script&lang=js&"
import style0 from "./HomeTitle.vue?vue&type=style&index=0&id=6fc72bb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc72bb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
